import { styled } from '@creditas-ui/system';
import { Flex } from '@creditas-ui/layout';
import { media, prop } from '@creditas-ui/utilities';

const DialogElement = styled(Flex)`
  width: 100vw;
  height: 100%;
  background-color: ${prop('theme.colors.neutral.0')};
  box-sizing: border-box;
  flex-direction: column;

  ${media.up('4xl')} {
    width: 576px;
  }
`;

export { DialogElement };
